import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@emotion/react';

import { IconButton } from '../../buttons';

type Props = {
  onDecrease: Function,
  icon: string,
  ariaLabel?: string,
  disabled?: boolean,
  size?: 'xsmall' | 'small' | 'large',
  buttonWithoutSpace?: boolean,
};

export const DecreaseQuantityIcon = ({ onDecrease, icon, disabled, size, buttonWithoutSpace, ariaLabel }: Props) => {
  const theme = useTheme();
  const { t } = useTranslation('');

  return (
    <IconButton
      onClick={onDecrease}
      dataTest="decrease-quantity-btn"
      icon={icon}
      backgroundColor={theme.color.white}
      borderColor={theme.color.lightGrey}
      ariaDisabled={disabled}
      size={size || 'small'}
      tooltip={t('common:remove')}
      touchTooltip={false}
      mode="light"
      withoutSpace={buttonWithoutSpace}
      ariaLabel={ariaLabel}
    />
  );
};
